<template>
  <textarea @input="handleInput" :value="localValue" :rows="rows" class="resize-none block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"/>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

const localValue = ref<string|null>(null);
const modelValue = defineModel<object|string|number|null>({
  default: null
});

const { rows = 4 } = defineProps<{
  readonly rows?: number;
}>();

function handleInput(event: Event): void {
  modelValue.value = (event.target as HTMLInputElement).value;
}

watch([modelValue], ([modelValue]) => {
  if (!modelValue && modelValue !== 0) {
    localValue.value = null;
    return;
  }

  localValue.value = modelValue.toString();
}, { immediate: true });
</script>